import { ReactRenderer } from "@tiptap/react";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import AnnotationMentionList from "../components/AnnotationMentionList";
import { ANNOTATIONS_MENTION_ALL } from "../../../i18n/keysTranslations";
import { MENTION_ALL_ID, buildMentionOptions } from "./annotationMentions";

const ANNOTATION_MENTION_TIPPY_STYLE_ID = "annotation-mention-tippy-theme";

const ensureAnnotationMentionTippyTheme = () => {
  if (typeof document === "undefined") return;
  if (document.getElementById(ANNOTATION_MENTION_TIPPY_STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = ANNOTATION_MENTION_TIPPY_STYLE_ID;
  style.textContent = `
    .tippy-box[data-theme~='annotation-mention'] {
      background-color: transparent;
      border: none;
      box-shadow: none;
      padding: 0;
      color: #212121;
    }
    .tippy-box[data-theme~='annotation-mention'] > .tippy-content {
      padding: 0;
      color: #212121;
    }
  `;
  document.head.appendChild(style);
};

export const createAnnotationMentionSuggestion = ({
  getOwnersByID = () => ({}),
  getExcludeUserID = () => null,
  getT = () => (key) => key,
  onOpenChange = () => {},
}) => ({
  char: "@",
  allowSpaces: false,
  items: ({ query }) => {
    const options = buildMentionOptions({
      ownersByID: getOwnersByID(),
      query,
      t: getT(),
      allLabelKey: ANNOTATIONS_MENTION_ALL,
      excludeUserID: getExcludeUserID(),
    });

    return options.map((option) => ({
      id: option.type === "all" ? MENTION_ALL_ID : option.id,
      label: option.label,
    }));
  },
  render: () => {
    let component;
    let popup;

    return {
      onStart: (props) => {
        onOpenChange(true);
        ensureAnnotationMentionTippyTheme();

        component = new ReactRenderer(AnnotationMentionList, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }

        popup = tippy("body", {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: "manual",
          placement: "top-start",
          offset: [0, 8],
          arrow: false,
          animation: false,
          maxWidth: "none",
          theme: "annotation-mention",
        });
      },
      onUpdate: (props) => {
        component?.updateProps(props);

        if (!props.clientRect || !popup?.[0]) {
          return;
        }

        popup[0].setProps({
          getReferenceClientRect: props.clientRect,
        });
      },
      onKeyDown: (props) => {
        if (props.event.key === "Escape") {
          popup?.[0]?.hide();
          return true;
        }

        return component?.ref?.onKeyDown(props) ?? false;
      },
      onExit: () => {
        onOpenChange(false);
        popup?.[0]?.destroy();
        component?.destroy();
      },
    };
  },
});
